import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { BASE_URL, BLACK, PRIMARY } from "../../../../appConstants";
import { Button, CircularProgress } from "@mui/joy";
import axios from "axios";
import appError from "../../../../appError";

const AmazonAdsAccess:React.FC<{}> = () => {
  const { brand_id } = useParams();
  const [toggleModal, setToggleModal] = useState<boolean>(false);
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  const getAccessObjects = async (ag_platformType: string, ag_platformId: string) => {
    const token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    try {
      setLoading(true);
      let api = `${BASE_URL}apiAccess/getAccessedProfileIdsAmazon?brand_id=${brand_id}&platform_id=${ag_platformId}&platform_type=${ag_platformType}`;
      const result = await axios.get(api, { headers });
      const {data} = result?.data?.data;
      const newData = data?.map((Obj: any) => {
        const {platform, platform_type, additional_data} = Obj;
        
        // Use a temporary variable for clarity and safety
        const profile = additional_data?.profile_obj;
      
        return {
          platform,
          platform_type,
          countryCode: profile?.countryCode,
          currencyCode: profile?.currencyCode,
          timezone: profile?.timezone,
          accountId: profile?.accountInfo?.id,
          accountName: profile?.accountInfo?.name,
          accountType: profile?.accountInfo?.type
        }
      });

      setData(newData);
      
    } catch (error) {
      appError(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(()=>{
    const brand = localStorage.getItem("brand");
    const platform = localStorage.getItem("platform");
    if (brand && platform) {
      try {
        const platformObject = JSON.parse(platform);
        
        getAccessObjects('Amazon Ads API', platformObject.platform_id);
      } catch (e) {
        appError("Failed to parse brand & platform data from localStorage", e);
        return;
      }
    }
  
  },[]);

  const redirectToWebsite = () => {
    const websiteURL = `https://eu.account.amazon.com/ap/oa?client_id=amzn1.application-oa2-client.b66a88f394174294823c2af2086e37e8&scope=advertising::campaign_management&response_type=code&redirect_uri=https://infytrix.com&state=amazon_eu_ads_app_one,${brand_id},Amazon%20Ads%20API`;
    window.open(websiteURL, '_blank');
  };

  return (

    <>
    {loading ? (
      <div style={{
        height: "calc(100vh - 72px - 52px)",
        width: "100vw",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}>
        <CircularProgress />
      </div>
    ) : (


    <div className="pt-6 pb-10 px-10 flex flex-col gap-4" style={{
      height: "calc(100vh - 72px - 52px)",
    }}>
      <div
        className="flex flex-row justify-between items-center px-6"
        style={{
          height: 96,
          borderRadius: 8,
          backgroundColor: PRIMARY.P_Purple50,
        }}
      >
        <div>
          <div
            className="mb-1"
            style={{ fontSize: 16, fontWeight: 600, lineHeight: "24px" }}
          >
            Add New Ads Access
          </div>
          <div
            style={{
              fontSize: 12,
              fontWeight: 400,
              lineHeight: "18px",
              color: BLACK.B_40,
            }}
          >
            {" "}
            Invite a new user and assign their role and permissions
          </div>
        </div>

        <Button
          // loading={loading}
          onClick={() => redirectToWebsite()}
          startDecorator={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M9.16663 10.8333H4.99996C4.76385 10.8333 4.56593 10.7535 4.40621 10.5937C4.24649 10.434 4.16663 10.2361 4.16663 9.99999C4.16663 9.76388 4.24649 9.56596 4.40621 9.40624C4.56593 9.24652 4.76385 9.16666 4.99996 9.16666H9.16663V4.99999C9.16663 4.76388 9.24649 4.56596 9.40621 4.40624C9.56593 4.24652 9.76385 4.16666 9.99996 4.16666C10.2361 4.16666 10.434 4.24652 10.5937 4.40624C10.7534 4.56596 10.8333 4.76388 10.8333 4.99999V9.16666H15C15.2361 9.16666 15.434 9.24652 15.5937 9.40624C15.7534 9.56596 15.8333 9.76388 15.8333 9.99999C15.8333 10.2361 15.7534 10.434 15.5937 10.5937C15.434 10.7535 15.2361 10.8333 15 10.8333H10.8333V15C10.8333 15.2361 10.7534 15.434 10.5937 15.5937C10.434 15.7535 10.2361 15.8333 9.99996 15.8333C9.76385 15.8333 9.56593 15.7535 9.40621 15.5937C9.24649 15.434 9.16663 15.2361 9.16663 15V10.8333Z"
                fill="white"
              />
            </svg>
          }
          sx={{
            fontSize: 14,
            fontWeight: 500,
            lineHeight: "20px",
            height: "48px",
            width: "200px",
            backgroundColor: PRIMARY.P_BLue,
          }}
        >
          Give Access
        </Button>
      </div>

      <div className=" w-full flex flex-wrap justify-center gap-4 p-4" style={{
        maxHeight: "calc(100vh - 72px - 52px - 24px - 48px - 16px - 40px)",
        overflow: "auto"
      }}>
      {data?.map((obj: any) => {
            return (
              <div className="self-stretch w-[40%] bg-white rounded-[8px] flex flex-col gap-1 p-4"
              style={{
                boxShadow: "0px 4px 10px 4px rgba(99, 99, 99, 0.05)",
              }}>
                <div className="text-center" style={{
                  fontSize: "18px",
                  lineHeight: "30px",
                  fontWeight: "bold",
                  borderBottom: "2px solid #EAEAED"
                }}>Entity ID: {obj?.accountId}</div>

                <div className="flex justify-between">
                  <div className="w-1/2">Account Name :</div>
                  <div className="w-1/2 text-end">{obj?.accountName}</div>
                </div>  

                <div className="flex justify-between">
                  <div className="w-1/2">Account Type :</div>
                  <div className="w-1/2 text-end">{obj?.accountType}</div>
                </div>  

                <div className="flex justify-between">
                  <div className="w-1/2">Platform :</div>
                  <div className="w-1/2 text-end">{obj?.platform}</div>
                </div>

                <div className="flex justify-between">
                  <div className="w-1/2">Platform Type:</div>
                  <div className="w-1/2 text-end">{obj?.platform_type}</div>
                </div>

                <div className="flex justify-between">
                  <div className="w-1/2">Country Code :</div>
                  <div className="w-1/2 text-end">{obj?.countryCode}</div>
                </div>  

                <div className="flex justify-between">
                  <div className="w-1/2">Currency :</div>
                  <div className="w-1/2 text-end">{obj?.currencyCode}</div>
                </div> 

                <div className="flex justify-between">
                  <div className="w-1/2">Timezone :</div>
                  <div className="w-1/2 text-end">{obj?.timezone}</div>
                </div>  
 
              </div>
            )
          })}
      </div>
    </div>
    )}
    </>
  );
};

export default AmazonAdsAccess;
